(function () {
  'use strict';

  angular.module('web2print.shared')
      .directive('teaserModal', teaserModal);

  /* @ngInject */
  function teaserModal () {
    return {
      restrict: 'E',
      templateUrl: 'components/landing/teaser-modal/teaser-modal.html',
      scope: {
        data: '='
      },
      controller: TeaserModalController,
      controllerAs: 'vm',
      bindToController: true
    };
  }

  TeaserModalController.$inject = ['$rootScope', '$window'];

  /* @ngInject */
  function TeaserModalController ($rootScope, $window) {
    const vm = this;

    vm.close = close;
    vm.login = login;
    vm.redirectToOnboarding = redirectToOnboarding;

    function close () {
      vm.data = {
        show: false,
        product: '',
        isLoggedIn: pnTopbar.isLoggedIn,
        isAgreementUser: $rootScope.isNCPUser()
      };
    }

    function login () {
      pnTopbar.login();
    }

    function redirectToOnboarding () {
      const market = pnTopbar.market;
      $window.location.href = `${web2print.env.onboardingPageUrl}?market=${market.toLowerCase()}`;
    }
  }

})();
